import { GLOBAL, ROUTE_NAME } from "@/core/constants";

import Layout from "@/views/layout/Layout.vue";
import Empty from "@/views/layout/Empty.vue";
import BlankPage from "@/views/layout/BlankPage.vue";
// GeneralViews
import NotFound from "@/views/pages/error/NotFoundPage.vue";

// Admin pages
import Home from "@/views/pages/home/Home.vue";
import Login from "@/views/pages/login/Login.vue";
// Role Permission
import RolePermissionList from "@/views/pages/role-permission/RolePermissionList.vue";
import RolePermissionDetails from "@/views/pages/role-permission/RolePermissionDetails.vue";
import RolePermissionNew from "@/views/pages/role-permission/RolePermissionNew.vue";
// DevOps
import DevOpsCreateAccount from "@/views/pages/devops/create-account/CreateAccount.vue";
import DevOpsAccountLogger from "@/views/pages/devops/account-logger/AccountLoggerList.vue";
// About Us
import Imprint from "@/views/pages/about-us/Imprint.vue";
import TermsOfUse from "@/views/pages/about-us/TermsOfUse.vue";
import DataProtectionStatement from "@/views/pages/about-us/DataProtectionStatement.vue";
import Cookies from "@/views/pages/about-us/Cookies.vue";

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: { name: ROUTE_NAME.HOME },
  },
  {
    path: "",
    redirect: { name: ROUTE_NAME.HOME },
    component: Layout,
    meta: {
      layout: GLOBAL.LAYOUT,
    },
    children: [
      {
        path: "home",
        name: ROUTE_NAME.HOME,
        component: Home,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
        children: [],
      },
    ],
  },
  {
    path: "/auth",
    redirect: { name: ROUTE_NAME.AUTH },
    component: Empty,
    meta: {
      layout: GLOBAL.LAYOUT,
    },
    children: [
      {
        path: "login",
        name: ROUTE_NAME.LOGIN,
        component: Login,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
        children: [],
      },
    ],
  },
  {
    path: "/role-permission",
    name: ROUTE_NAME.ROLE_PERMISSION,
    redirect: { name: ROUTE_NAME.ROLE_PERMISSION_LIST },
    component: Layout,
    meta: {
      layout: GLOBAL.LAYOUT,
    },
    children: [
      {
        path: "list",
        name: ROUTE_NAME.ROLE_PERMISSION_LIST,
        component: RolePermissionList,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
        children: [],
      },
      {
        path: "details/:id",
        name: ROUTE_NAME.ROLE_PERMISSION_DETAILS,
        component: RolePermissionDetails,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
        children: [],
      },
      {
        path: "new",
        name: ROUTE_NAME.ROLE_PERMISSION_NEW,
        component: RolePermissionNew,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
        children: [],
      },
    ],
  },
  {
    path: "/devOps",
    name: ROUTE_NAME.DEVOPS,
    component: Layout,
    meta: {
      layout: GLOBAL.LAYOUT,
    },
    children: [
      {
        path: "create-account",
        name: ROUTE_NAME.DEVOPS_CREATE_ACCOUNT,
        component: DevOpsCreateAccount,
        meta: {
          layout: GLOBAL.LAYOUT,
        },

        children: [],
      },
      {
        path: "account-logger",
        name: ROUTE_NAME.DEVOPS_ACCOUNT_LOGGER,
        component: DevOpsAccountLogger,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
        children: [],
      },
    ],
  },
  {
    path: "/about-us",
    redirect: { name: ROUTE_NAME.AUTH },
    component: BlankPage,
    meta: {
      layout: GLOBAL.LAYOUT,
    },
    children: [
      {
        path: "Imprint",
        name: ROUTE_NAME.IMPRINT,
        component: Imprint,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
      },
      {
        path: "terms-of-use",
        name: ROUTE_NAME.TERMS_OF_USE,
        component: TermsOfUse,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
      },
      {
        path: "data-protection-statement",
        name: ROUTE_NAME.DATA_PROTECTION_STATEMENT,
        component: DataProtectionStatement,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
      },

      {
        path: "cookies",
        name: ROUTE_NAME.COOKIES,
        component: Cookies,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
      },
    ],
  },

  // {
  //   path: "",
  //   name: ROUTE_NAME.OVERVIEW,
  //   redirect: { name: ROUTE_NAME.OVERVIEW },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "overview",
  //       name: ROUTE_NAME.OVERVIEW,
  //       component: Overview,
  //       children: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/table",
  //   name: ROUTE_NAME.TABLE,
  //   redirect: { name: ROUTE_NAME.TABLE_LIST },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "list",
  //       name: ROUTE_NAME.TABLE_LIST,
  //       component: TableList,
  //       children: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/user",
  //   name: ROUTE_NAME.USER,
  //   redirect: { name: ROUTE_NAME.USER_PROFILE },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "user-profile",
  //       name: ROUTE_NAME.USER_PROFILE,
  //       component: UserProfile,
  //       children: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/typography",
  //   name: ROUTE_NAME.TYPOGRAPHY,
  //   redirect: { name: ROUTE_NAME.TYPOGRAPHY },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       name: ROUTE_NAME.TYPOGRAPHY,
  //       component: Typography,
  //       children: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/icons",
  //   name: ROUTE_NAME.ICONS,
  //   redirect: { name: ROUTE_NAME.ICONS },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       name: ROUTE_NAME.ICONS,
  //       component: Icons,
  //       children: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/maps",
  //   name: ROUTE_NAME.MAPS,
  //   redirect: { name: ROUTE_NAME.MAPS },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       name: ROUTE_NAME.MAPS,
  //       component: Maps,
  //       children: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/notifications",
  //   name: ROUTE_NAME.NOTIFICATIONS,
  //   redirect: { name: ROUTE_NAME.NOTIFICATIONS },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "",
  //       name: ROUTE_NAME.NOTIFICATIONS,
  //       component: Notifications,
  //       children: [],
  //     },
  //   ],
  // },

  // Error ::start
  {
    path: "/error",
    component: NotFound,
    children: [
      {
        path: "403",
        name: ROUTE_NAME.ERROR_403,
        component: NotFound,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
      },
      {
        path: "404",
        name: ROUTE_NAME.ERROR_404,
        component: NotFound,
        meta: {
          layout: GLOBAL.LAYOUT,
        },
      },
    ],
  },
  // Error ::end

  // Login (/) ::start
  {
    path: "/",
    redirect: { name: ROUTE_NAME.OVERVIEW },
  },
  // Login (/)::end

  // Error 404 ::start
  {
    path: "*",
    redirect: { name: ROUTE_NAME.ERROR_404 },
  },
  // Error 404 ::end
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
